
import LoyaltyRewards from '@/pages/account/components/LoyaltyRewards.vue';
import cartMixin from '@/mixins/cartMixin.js';
import { Button } from 'element-ui';
export default {
  mixins: [cartMixin],

  data() {
    return {
      loading: false,
      rewardsLimit: 3,
    };
  },

  computed: {
    customer() {
      return this.$store.state.shop.loyalty.customer;
    },
    listMyRewards() {
      return this.$store.state.shop.loyalty.myRewards.LoyaltyRewards;
    },
    rewardsCount() {
      return this.listMyRewards?.length || 0;
    },
    visibleRewards() {
      return (this.listMyRewards || []).slice(0, this.rewardsLimit);
    },
    myRewardsState() {
      return this.$store.state.shop.loyalty.myRewards.LoyaltyRewardState;
    },
  },
  watch: {
    rewardsCount() {
      this.rewardsLimit = 3;
    },
  },
  mounted() {
    if (this.$auth.loggedIn) {
      this.$store.dispatch('shop/loyalty/fetchMyRewards', {
        loyaltyRewardState: 'available',
      });
      this.$store.dispatch('shop/loyalty/fetchLoyaltyCustomer');
      this.$store.dispatch('shop/loyalty/fetchRewards');
    }
  },
  methods: {
    applyCode(code) {
      this.$store
        .dispatch('shop/codepromo/apply', {
          code: code,
          idCart: this.cart?.IdCart,
          loyaltyRewardStateLabel: 'available',
        })
        .then((data) => {
          this.cartService.fetchCart();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    isUsed(code) {
      return this.cart?.Discounts?.PromoCodes?.some((cp) => cp.Code === code);
    },
  },
  components: {
    LoyaltyRewards,
    Button,
  },
};
